"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var React = require('react');
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        _super.apply(this, arguments);
    }
    default_1.prototype.render = function () {
        var _a = this.props, isActive = _a.isActive, rowIndex = _a.rowIndex, cellIndex = _a.cellIndex, alterBoard = _a.alterBoard;
        return (React.createElement("div", {className: "cell" + (isActive ? ' cell--active' : '') + (alterBoard ? ' cell--interactive' : ''), onClick: alterBoard ?
            function () { return alterBoard(rowIndex, cellIndex); }
            : undefined}));
    };
    return default_1;
}(React.PureComponent));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;



/*****************
 ** WEBPACK FOOTER
 ** ./src/components/cell.tsx
 ** module id = 6
 ** module chunks = 0
 **/